import React, {
  useEffect, useMemo, useState,
} from 'react';
import { useSelector } from 'react-redux';

import { selectInfiniteScrollIsBottom } from 'redux/reducers/infiniteScrollReducer';
import StatusAccordionItem, { StatusListItem } from 'components/NewHome/Mobile/StatusAccordionItem';

import './index.scss';

const PAGE_SIZE = 20;

export default function MobileStatusList({ items }: { items: StatusListItem[] }) {
  const [openKey, setOpenKey] = useState<string | number | null>(null);
  const [visibleCount, setVisibleCount] = useState<number>(PAGE_SIZE);
  const isBottom = useSelector(selectInfiniteScrollIsBottom);

  useEffect(() => {
    if (isBottom) {
      setVisibleCount((count) => Math.min(count + PAGE_SIZE, items.length));
    }
  }, [isBottom, items.length]);

  const visibleItems = useMemo(
    () => items.slice(0, visibleCount),
    [items, visibleCount],
  );

  if (items.length === 0) {
    return <p className="status-list-empty">Nenhum resultado encontrado.</p>;
  }

  return (
    <div className="status-list">
      {visibleItems.map((item) => (
        <StatusAccordionItem
          key={item.key}
          item={item}
          isOpen={openKey === item.key}
          onToggle={() => setOpenKey((current) => (current === item.key ? null : item.key))}
        />
      ))}
    </div>
  );
}
